export default __webpack_public_path__ + "static/media/jess-snoek-rDud6SN-ZVo-unsplash_MOBILE.1aa3ec19.jpg";